import { render, staticRenderFns } from "./SimpleFerry.vue?vue&type=template&id=efd024de&"
import script from "./SimpleFerry.vue?vue&type=script&lang=js&"
export * from "./SimpleFerry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports